import { NidoCage } from '~/service/experience/world/nido/parts/NidoCage'
import { NidoSeat } from '~/service/experience/world/nido/parts/NidoTexturePart'
import {
  NidoHighBackrest,
  NidoPillow,
  NidoLowBackrest,
} from '~/service/experience/world/nido/parts/NidoTexturePart'
import NidoSocket from '~/service/experience/world/nido/parts/NidoSocket'
import NidoTable from '~/service/experience/world/nido/parts/NidoTable'

export function isNidoCage(obj: any): obj is NidoCage {
  return obj instanceof NidoCage
}

export function isNidoSeat(obj: any): obj is NidoSeat {
  return obj instanceof NidoSeat
}

export function isNidoLowBackrest(obj: any): obj is NidoLowBackrest {
  return obj instanceof NidoLowBackrest
}

export function isNidoHighBackrest(obj: any): obj is NidoHighBackrest {
  return obj instanceof NidoHighBackrest
}

export function isNidoPillow(obj: any): obj is NidoPillow {
  return obj instanceof NidoPillow
}

export function isNidoSocket(obj: any): obj is NidoSocket {
  return obj instanceof NidoSocket
}

export function isNidoTable(obj: any): obj is NidoTable {
  return obj instanceof NidoTable
}
